import { Button, InfiniteScroll, printComponent, Progress } from "nq-component";
import BaseListPage from "../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import PositionTitlePresenter from "./PositionTitlePresenter";
import CardView from "../../../components/common/CardView";
import Search from "../../../components/Search";
import Table from "../../../components/Table";
import withRouter from "../../../withRouter";
import PrintComponent from "./PrintComponent";
import React from "react";
import { DialogConfirmation } from "../../../components/common/Converter";
import InputFactory from "../../../components/InputFactory";

class PositionTitlePage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new PositionTitlePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );

    this.state = {
      objects: [],
      description: "",
      sendToAll: false,
      offices: [],
      count: 0,
      limit: 10,
      current: 1,
      // fields: {}
    };
    // this.contractPDF = React.createRef();
  }

  // delete function
  // async handleDeleteData(id) {
  //   await this.presenter.deleteObjectUseCase.execute(
  //     this.getCollectionName(),
  //     id
  //   );
  //   this.refetchData();
  // }

  // delete function
  async handleDeleteData(data) {
    DialogConfirmation(data.id, this.getCollectionName(), () =>
      this.refetchData()
    );
  }

  // edit function
  async handleEditData(id) {
    this.navigateTo(`/form/${this.getCollectionName()}/${id}`);
    // this.refetchData();
  }

  async handleViewObject(id) {
    this.navigateTo(`/view/${this.getCollectionName()}/${id?.id}`);
  }

  handlePrintData(obj) {
    // this.setState({ object: obj }, () => {
    //   // Callback function to ensure state is updated before printing
    //   printComponent(this.contractPDF.current);
    // });
    PrintComponent({ obj });
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  getCollectionName() {
    return "position_titles";
  }

  addNotices() {
    this.navigateTo(`/form/${this.getCollectionName()}/`);
  }

  submitMe() {
    upsertUseCase().execute(this.getCollectionName(), this.state);
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit } = this.state;
    console.log("OBEJCTS: ", objects);
    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();
    const exludeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "position_title" &&
        fields !== "salary_grade" &&
        fields !== "createdAt"
    );

    return (
      <>
        {/* <div className="d-none2">
          <div ref={this.contractPDF} id="contractPDF">
            <PrintComponent object={object} />
          </div>
        </div> */}
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Recruitment {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                {/* <Search
                  schemas={this.getSchemas()}
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                /> */}
                <div className="d-flex gap-4">
                  {Object.keys(schema.filters || {}).map((field) => {
                    let { type, ...options } = schema.filters[field];
                    return (
                      <InputFactory
                        key={field}
                        className="ms-1"
                        type={type}
                        field={field}
                        where={{}}
                        onChange={this.onChangeFilter.bind(this, type)}
                        {...options}
                      />
                    );
                  })}
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div style={{ marginLeft: "auto" }}>
                      <Button onClick={this.addNotices.bind(this)}>
                        <i className="bi bi-plus-lg" /> New {schema.label}
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                // // objectId={this.handleViewObject.bind(this)}
                // objectId={this.handleViewObject.bind(this)}
                // // objectData={this.handlePrintData.bind(this)}
                objectId={this.handleDeleteData.bind(this)}
                editId={this.handleEditData.bind(this)}
                viewObject={this.handleViewObject.bind(this)}
                // hrAction={this.handleViewData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  // {
                  //   label: <i className="bi bi-search"> View</i>,
                  //   actionType: "delete",
                  // },
                  // {
                  //   label: <i className="bi bi-trash"> Delete</i>,
                  //   actionType: "delete",
                  // },
                  // {
                  //   label: <i className="bi bi-pencil"> Edit</i>,
                  //   actionType: "edit",
                  // },
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "common",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At", ...exludeLabel]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(PositionTitlePage);
